module.exports = __webpack_public_path__ + "img/pain-point-1.032caa58.svg";